export default "__VITE_ASSET__CDLHjiuL__"